import { connect } from "react-redux";
import Container from "./container";
import { actionCreators as userActions } from "stores/user";

const mapStateToProps = state => {
    const { user: { isLoggedIn, userInfo, userInfo: { roles = [] } } } = state;
    return {
        isLoggedIn,
        userInfo,
        roles,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(userActions.logout());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
